export { default as GDMPageCardFooter } from './GDMPageCardFooter';

export type {
  GDMPageCardFooterAction,
  GDMPageCardFooterActionProps,
  GDMPageCardFooterComponent,
  GDMPageCardFooterProps,
} from './GDMPageCardFooter.type';
